import { AudienceConstants } from 'types/api/audience/enums';

export const defaultCategories = [AudienceConstants.Attributes, AudienceConstants.RFM];
